import { useEffect, useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    // For /addin route, let AddInWrapper handle dialog authentication
    if (location.pathname === '/addin') {
      return <>{children}</>;
    }
    
    // For other routes, redirect to /auth
    const redirectParam = encodeURIComponent(location.pathname);
    return <Navigate to={`/auth?redirect=${redirectParam}`} replace />;
  }

  return <>{children}</>;
};